







































































import {
  defineNuxtComponent,
  PropType,
  computed
} from '~/utils/nuxt3-migration'
import { ciAngleRight } from '~/icons/source/regular/angle-right'
import { ciAngleDown } from '~/icons/source/regular/angle-down'
import { Searchable } from '~/models/search/types'

export default defineNuxtComponent({
  name: 'ClassifiedSearchCategoryPickerChildCategory',
  props: {
    category: {
      type: Object as PropType<Searchable>,
      required: true
    },
    selectedCategories: {
      type: Array as PropType<(string | number)[]>,
      required: true
    }
  },
  setup(props) {
    const isSelected = computed(() => {
      return props.selectedCategories.includes(props.category.v)
    })

    const isDisabled = computed(
      () => props.category.c === 0 && !isSelected.value
    )

    function formatCount(count: number): string {
      if (!count) {
        return '0'
      }

      if (count < 1000) {
        return count.toString()
      } else if (count < 1000000) {
        return (count / 1000).toFixed(1).replace(/\.0$/, '') + 'K'
      } else {
        return (count / 1000000).toFixed(1).replace(/\.0$/, '') + 'M'
      }
    }

    return {
      isDisabled,
      isSelected,
      ciAngleRight,
      ciAngleDown,
      formatCount
    }
  }
})
